"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileButton = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../../elements/button/Button");
var _noop = require("../../../utils/noop");
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _file = require("../../../assets/icons/file.svg");
var _fileButtonModule = _interopRequireDefault(require("./file-button.module.scss"));
var _excluded = ["onError", "onChange", "value", "maxSizeMb", "disabled", "allowedFileTypes", "children", "level", "small", "data-testid"];
var FileButton = function FileButton(_ref) {
  var _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? _noop.noop : _ref$onError,
    onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? [] : _ref$value,
    _ref$maxSizeMb = _ref.maxSizeMb,
    maxSizeMb = _ref$maxSizeMb === void 0 ? 1 : _ref$maxSizeMb,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    allowedFileTypes = _ref.allowedFileTypes,
    children = _ref.children,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 'neutral' : _ref$level,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    testId = _ref['data-testid'],
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var fileRef = (0, _react.useRef)(null);
  var handleFileChange = (0, _react.useCallback)(function (_ref2) {
    var target = _ref2.target;
    var files = target.files;
    if ((0, _toConsumableArray2.default)(files).some(function (f) {
      return f.size > maxSizeMb * 1024 * 1024;
    })) {
      return onError({
        error: t('fileUploader.fileSizeError', {
          maxSizeMb: maxSizeMb
        })
      });
    }
    onChange([].concat((0, _toConsumableArray2.default)(value), (0, _toConsumableArray2.default)(files)), true);
  }, [maxSizeMb, onError, t, value, onChange]);
  var handleUploadClick = (0, _react.useCallback)(function () {
    /* istanbul ignore */
    fileRef.current && fileRef.current.click();
  }, [fileRef]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _fileButtonModule.default['file-button'],
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement("input", Object.assign({
    "data-testid": "file-input",
    type: "file",
    hidden: true,
    ref: fileRef,
    onChange: handleFileChange,
    accept: allowedFileTypes.join(', ')
  }, rest)), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    level: level,
    "data-testid": "file-button",
    onClick: handleUploadClick,
    disabled: disabled,
    small: small,
    className: _fileButtonModule.default['file-button__button']
  }, /*#__PURE__*/_react.default.createElement(_file.ReactComponent, {
    className: _fileButtonModule.default['file-button__icon']
  }), children));
};
exports.FileButton = FileButton;